import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { getPlatformFromUrl, Platform } from "./platform-mapping";
import { toast } from "react-hot-toast";

export const authClient = createAuthClient({
  baseURL: process.env.REACT_APP_AUTH_URL,
  plugins: [
    inferAdditionalFields({
      user: {
        platform: {
          type: "string",
          required: true,
        },
        platform_data: {
          type: "string",
          required: true,
        },
      },
    }),
  ],
});

type registerInput = {
  email: string;
  password: string;
  fullName: string;
};
export const register = async (data: registerInput) => {
  const platform = getPlatformFromUrl();
  console.log({ data });
  console.log({ platform });
  await authClient.signUp.email(
    {
      email: data.email,
      password: data.password,
      name: data.fullName,
      platform: platform.id,
      platform_data: JSON.stringify({ test: true }),
    },
    {
      onSuccess: (data) => {
        const token = data.response.headers.get("set-auth-token");
        if (!token) {
          throw new Error("Failed to register server error");
        }
        localStorage.setItem("token", token);
        toast.success("Account created successfully");
      },
      onError: (error) => {
        console.log(`error: ${JSON.stringify(error)}`);
        toast.error("Account creation failed");
        throw new Error(error.error.message);
      },
    }
  );
};

type loginInput = {
  email: string;
  password: string;
};
export const login = async (data: loginInput) => {
  await authClient.signIn.email(
    {
      ...data,
    },
    {
      onSuccess: async (data) => {
        const session = await authClient.getSession();
        const registeredPlatforms = (session as any).data.platforms;
        const platform = getPlatformFromUrl();

        //Enter remaining data if not registered //
        if (!registeredPlatforms.includes(platform.id)) {
          const response = await authClient.updateUser({
            platform: platform.id,
            platform_data: JSON.stringify({ test: true }), // Add custom platform data
          });
          if (response.error) {
            // Error updating user stop signing in //
            throw Error(
              response.error.message || "Login failed. Please try again."
            );
          }
        }

        // Set token and redirect to dashboard //
        localStorage.setItem(
          "token",
          data.response.headers.get("set-auth-token") || ""
        );
      },
      onError: (error) => {
        throw new Error(error.error.message);
      },
    }
  );
};
